export const environment = {
    production: false,
    API_URL: "https://api-development-direkt.help2engg.com/api/",
    CLOUDFRONT_URL: "https://d3om06iw6o6an5.cloudfront.net/",
    IMAGE_URL: "https://d3om06iw6o6an5.cloudfront.net/_media/direkt/",
    GOOGLE_CLIENT_ID: "527115533503-8r8of3tm5n0ooel9pp8s40l6jj3tfq7e.apps.googleusercontent.com",
    ADMIN_USER_ID: "40",
    DOMAIN: "https://direkt-development.help2engg.com/",
    // FACEBOOK_CLIENT_ID: '621115146259879'
};
